export enum MEDIAS {
    /**
     * @value Add files
     */
    ADD_FILES = 'FRONT.ATTACHMENTS.ADD_FILES',
    /**
     * @value Add images
     */
    ADD_IMAGES = 'FRONT.ATTACHMENTS.ADD_MEDIA',
    /**
     * @value Deleting the media %MEDIA_NAME% is irreversible.
     * @description Message of the dialog displayed when the user wants to delete a media from the trash
     */
    CONFIRM_DELETE_MEDIA_MESSAGE = 'MEDIAS.CONFIRM_DELETE_MEDIA_MESSAGE',
    /**
     * @value Delete media?
     * @description Title of a dialog that asks the user to confirm that she actually wants to permanently delete a media
     */
    CONFIRM_DELETE_MEDIA_TITLE = 'MEDIAS.CONFIRM_DELETE_MEDIA_TITLE',
    /**
     * @value Emptying the trash is irreversible. You will lose all media in the trash.
     * @description Message of the dialog displayed when the user wants to permanently empty the media trash
     */
    CONFIRM_EMPTY_TRASH_MESSAGE = 'MEDIAS.CONFIRM_EMPTY_TRASH_MESSAGE',
    /**
     * @value Empty trash?
     * @description Title of a dialog that asks the user to confirm that she actually wants to empty the media trash
     */
    CONFIRM_EMPTY_TRASH_TITLE = 'MEDIAS.CONFIRM_EMPTY_TRASH_TITLE',
    /**
     * @value This media will be moved back to the media library.
     * @description Message of the dialog displayed when a user wants to restore a deleted media
     */
    CONFIRM_RESTORE_MEDIA_MESSAGE = 'MEDIAS.CONFIRM_RESTORE_MEDIA_MESSAGE',
    /**
     * @value Restore media?
     * @description Title of a dialog that asks the user to confirm that she actually wants to restore a media
     */
    CONFIRM_RESTORE_MEDIA_TITLE = 'MEDIAS.CONFIRM_RESTORE_MEDIA_TITLE',
    /**
     * @value Download %FILE_NAME% (%FILE_SIZE%)
     */
    DOWNLOAD_FILE_NAME_WITH_SIZE = 'GLOBAL.DOWNLOAD_FILE_NAME_WITH_SIZE',
    /**
     * @value Empty folder
     */
    EMPTY_FOLDER = 'MEDIAS.EMPTY_FOLDER',
    /**
     * @value Empty trash
     */
    EMPTY_TRASH = 'FRONT.MEDIA_PICKER.HEADER_EMPTY_TRASH',
    /**
     * @value File deleted
     */
    FILE_DELETED = 'FRONT.DOCUMENT.DELETE.FILE.SUCCESS',
    /**
     * @value %FILE_NAME% file moved with success
     */
    FILE_MOVED = 'MEDIAS.FILE_MOVED',
    /**
     * @value %FILE_SIZE% bytes
     */
    FILE_SIZE_B = 'GLOBAL.FILE_SIZE_B',
    /**
     * @value %FILE_SIZE% GB
     */
    FILE_SIZE_GB = 'GLOBAL.FILE_SIZE_GB',
    /**
     * @value %FILE_SIZE% kB
     */
    FILE_SIZE_KB = 'GLOBAL.FILE_SIZE_KB',
    /**
     * @value %FILE_SIZE% MB
     */
    FILE_SIZE_MB = 'GLOBAL.FILE_SIZE_MB',
    /**
     * @value %FOLDER_NAME% folder moved with success
     */
    FOLDER_MOVED = 'MEDIAS.FOLDER_MOVED',
    /**
     * @value Pick from Google Drive
     * @description Text displayed on the dropdown media picker to allow the user to select a file from Google drive
     */
    FROM_GOOGLE_DRIVE = 'MEDIAS.PICK_FILE_FROM_GOOGLE_DRIVE',
    /**
     * @value Pick from media library
     * @description The label of the dropdown option to add as attachments some files from your the media library in a post.
     */
    FROM_MEDIA_LIBRARY = 'FRONT.POST_DIALOG.ADD_ATTACHMENTS.FROM_MEDIA_LIBRARY',
    /**
     * @value Pick from SharePoint
     * @description Text displayed on the dropdown media picker to allow the user to select a file from Microsoft SHAREPOINT
     */
    FROM_MICROSOFT_SHAREPOINT = 'MEDIAS.PICK_FILE_FROM_MICROSOFT_SHAREPOINT',
    /**
     * @value Up to 20 files
     */
    MAX_FILES = 'MEDIAS.MAX_FILES',
    /**
     * @value Library
     */
    MEDIA_LIBRARY = 'ADMIN.NAV.MEDIA_LIBRARY',
    /**
     * @value Trash
     */
    MEDIA_TRASH = 'ADMIN.NAV.MEDIA_TRASH',
    /**
     * @value Media
     */
    NAV_MEDIA = 'ADMIN.NAV.MEDIA',
    /**
     * @value Next image
     * @description `Next image` label for an image slideshow
     */
    NEXT_IMAGE = 'MEDIAS.NEXT_IMAGE',
    /**
     * @value No media yet
     */
    NO_MEDIA_YET = 'MEDIAS.NO_MEDIA_YET',
    /**
     * @value Open folder
     */
    OPEN_FOLDER = 'MEDIAS.OPEN_FOLDER',
    /**
     * @value Previous image
     * @description `Previous image` label for an image slideshow
     */
    PREVIOUS_IMAGE = 'MEDIAS.PREVIOUS_IMAGE',
    /**
     * @value Remove image
     */
    REMOVE_IMAGE = 'MEDIAS.REMOVE_IMAGE',
    /**
     * @value {"one":"%COUNT% folder selected","other":"%COUNT% folders selected"}
     */
    SELECTED_FOLDERS_COUNT = 'MEDIAS.SELECTED_FOLDERS_COUNT',
    /**
     * @value Select folders
     * @description Title of the Folder Picker when it's in multiple selection mode
     */
    SELECT_FOLDERS = 'MEDIAS.SELECT_FOLDERS',
}
